import React, { useEffect } from 'react';
import HomePage from './pages/HomePage';
import DocumentsPage from './pages/DocumentsPage';
import SettingsPage from './pages/SettingsPage';
import FeedbackPage from './pages/FeedbackPage';
import RequestsPage from './pages/RequestsPage';
import NewsPage from './pages/NewsPage';
import ReviewsPage from './pages/ReviewsPage';
import { Route } from 'react-router-dom';

const HomeRedirect = ({history}) => {
  useEffect(() => {
    history.replace('/profile/home');
  }, [history]);
  return null;
};

const routes = () => [
  <Route key="/profile" exact path="/profile" component={HomeRedirect} />,
  <Route key="/profile/home" exact path="/profile/home" component={HomePage} />,
  <Route key="/profile/documents" exact path="/profile/documents" component={DocumentsPage} />,
  // <Route key="/profile/people" exact path="/profile/people" component={BasePage} />,
  // <Route key="/profile/calendar" exact path="/profile/calendar" component={BasePage} />,
  <Route key="/profile/requests" exact path="/profile/requests" component={RequestsPage} />,
  // <Route key="/profile/information" exact path="/profile/information" component={BasePage} />,
  <Route key="/profile/news" exact path="/profile/news" component={NewsPage} />,
  <Route key="/profile/my-reviews" exact path="/profile/my-reviews" component={ReviewsPage} />,
  <Route key="/profile/settings" exact path="/profile/settings" component={SettingsPage} />,
  <Route key="/profile/feedback" exact path="/profile/feedback" component={FeedbackPage} />,
];
export default routes;
